import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MatDialogModule} from '@angular/material/dialog';
import {PrimaryButtonComponent, SecondaryButtonComponent} from '@q9elements/ui-kit/components';
import {NgSwitch, NgSwitchCase} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ExternalGptConfig} from '../../models/generate-stories-dialog';

@Component({
  selector: 'app-explain-rules-content',
  templateUrl: './explain-rules-content.component.html',
  styleUrls: ['../../generate-stories-ai-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    NgSwitch,
    NgSwitchCase,
    TranslateModule
  ]
})
export class ExplainRulesContentComponent implements OnInit {
  @Input() public externalGptConfig: ExternalGptConfig;
  @Input() public articleLink: string;
  @Input() public disableAction: boolean = false;

  @Output() public changeStep = new EventEmitter<number>();

  public generationEnabled: boolean;
  public needExternalGptConfig: boolean;

  ngOnInit(): void {
    this.generationEnabled =
      (this.externalGptConfig.enabled && this.externalGptConfig.validCredentials) ||
      !this.externalGptConfig.enabled;
    this.needExternalGptConfig =
      this.externalGptConfig.enabled && !this.externalGptConfig.validCredentials;
  }

  public readArticle() {
    window.open(this.articleLink, '_blank');
  }
}
